import { Link } from 'react-router-dom'
import { circleModelPath } from '../lib/teamLinks'

export interface SummaryCircle {
  id: string
  purpose: string
  roles: Array<{ id: string; name: string }>
}

interface CircleRoleSummaryProps {
  teamId: string
  circles: SummaryCircle[]
  onOpen?: (circleId: string, roleId?: string) => void
}

/**
 * * Same reading as the team table: circle, then its roles on the next indented line.
 */
export function CircleRoleSummary({ teamId, circles, onOpen }: CircleRoleSummaryProps) {
  if (circles.length === 0) {
    return <p className="text-sm text-secondary">Aucun cercle</p>
  }
  return (
    <div className="text-sm text-primary max-w-xl">
      {circles.map((circle) => (
        <div key={circle.id}>
          <Link
            className="text-robot-blue"
            style={{ textDecoration: 'underline' }}
            to={circleModelPath(teamId, circle.id)}
            onClick={() => onOpen?.(circle.id)}
          >
            {circle.purpose.trim() || 'Cercle'}
          </Link>
          {' :'}
          <div style={{ paddingLeft: '1.5rem' }}>
            {circle.roles.map((role, index) => (
              <span key={role.id}>
                {index > 0 ? ', ' : null}
                <Link
                  className="text-robot-blue"
                  style={{ textDecoration: 'underline' }}
                  to={circleModelPath(teamId, circle.id, role.id)}
                  onClick={() => onOpen?.(circle.id, role.id)}
                >
                  {role.name}
                </Link>
              </span>
            ))}
            {' ;'}
          </div>
        </div>
      ))}
    </div>
  )
}
